import { jsxs as L, jsx as r } from "react/jsx-runtime";
const n = ({ size: o, className: t }) => /* @__PURE__ */ L(
  "svg",
  {
    className: t,
    fill: "none",
    height: o,
    viewBox: "0 0 20 20",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r(
        "path",
        {
          d: "M7.71837 7.07959L8.85714 7.42857L7.71837 7.77755C6.78775 8.06531 6.06531 8.79388 5.77755 9.71837L5.42857 10.8571L5.07959 9.71837C4.79184 8.78776 4.06327 8.06531 3.13878 7.77755L2 7.42857L3.13878 7.07959C4.06939 6.79184 4.79184 6.06327 5.07959 5.13878L5.42857 4L5.77755 5.13878C6.06531 6.06327 6.79388 6.79184 7.71837 7.07959Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M13.8971 14.8678L13.4286 16.5714L12.96 14.8678C12.5771 13.4728 11.6114 12.3864 10.3714 11.9557L8.85714 11.4286L10.3714 10.9014C11.6114 10.4707 12.5771 9.38428 12.96 7.98928L13.4286 6.28571L13.8971 7.98928C14.28 9.38428 15.2457 10.4707 16.4857 10.9014L18 11.4286L16.4857 11.9557C15.2457 12.3864 14.28 13.4728 13.8971 14.8678Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.9"
        }
      )
    ]
  }
);
export {
  n as NewCarsV2
};
